import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'currency-converter',
  templateUrl: './currency-converter.component.html',
  styleUrls: ['./currency-converter.component.scss']
})
export class CurrencyConverterComponent implements OnInit {
  @Input() amount;
  @Input() currencyCode;

  baseCurrencyUrl = 'https://www.oanda.com/currency/converter?exch=USD&quote_amount={0}&quote_currency={1}&_={2}';
  currencyConverterUrl: string;
  currencyTimestamp: number;

  constructor() { }

  ngOnInit() {
    this.updateTimestamp();
  }

  updateTimestamp() {
    this.currencyTimestamp = new Date().getTime();
    this.setCurrencyUrl();
  }

  setCurrencyUrl() {
    this.currencyConverterUrl = this.baseCurrencyUrl.replace('{0}', this.amount.toString()).replace('{1}', this.currencyCode).replace('{2}', this.currencyTimestamp.toString());
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/currency-converter/currency-converter.component.ts